import { render, staticRenderFns } from "./EventosAntigos2.vue?vue&type=template&id=43083a46"
import script from "./EventosAntigos2.vue?vue&type=script&lang=js"
export * from "./EventosAntigos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports